var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 48,
      height: 48,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4B4B4B;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,47.7v416.6h512V47.7H0z M50.881,413.415V98.585h410.238v314.83H50.881z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.51,
    y: 159.004,
    className: "st0",
    width: 178.086,
    height: 34.985,
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.51,
    y: 238.508,
    className: "st0",
    width: 178.086,
    height: 34.985,
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.404,
    y: 318.011,
    className: "st0",
    width: 321.192,
    height: 34.984,
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.646,204.463c19.107,0,34.652-15.548,34.652-34.655s-15.546-34.654-34.652-34.654 c-19.106,0-34.649,15.547-34.649,34.654S133.54,204.463,152.646,204.463z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.295,247.926c0-13.222-9.276-29.142-21.118-36.242l-0.376-0.229h-34.307l-0.376,0.229 c-11.842,7.1-21.118,23.02-21.118,36.242v25.567h77.296V247.926z",
    style: {
      fill: "rgb(17, 104, 173)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAccount);
export default __webpack_public_path__ + "static/media/SubAccount.02b6660ff36d67c5d6b0e19af90e7ad3.svg";
export { ForwardRef as ReactComponent };